import { render, staticRenderFns } from "./staff_handover.vue?vue&type=template&id=38245ec0&scoped=true"
import script from "./staff_handover.vue?vue&type=script&lang=js"
export * from "./staff_handover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38245ec0",
  null
  
)

export default component.exports